const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1", "::1"]);

const AUTOMATION_UA_PATTERNS = [
  "selenium",
  "webdriver",
  "headless",
  "phantomjs",
  "puppeteer",
  "playwright",
  "cypress",
  "bot",
  "crawler",
  "spider",
];

export function isLocalhostHost(): boolean {
  if (typeof window === "undefined") return false;
  return LOCAL_HOSTS.has(window.location.hostname.toLowerCase());
}

export function isAutomationBrowser(): boolean {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }

  const ua = (navigator.userAgent || "").toLowerCase();
  if (AUTOMATION_UA_PATTERNS.some((pattern) => ua.includes(pattern))) {
    return true;
  }

  if (navigator.webdriver === true) {
    return true;
  }

  const runtimeWindow = window as Window & {
    callPhantom?: unknown;
    _phantom?: unknown;
    __nightmare?: unknown;
    domAutomation?: unknown;
    domAutomationController?: unknown;
  };

  if (
    runtimeWindow.callPhantom !== undefined ||
    runtimeWindow._phantom !== undefined ||
    runtimeWindow.__nightmare !== undefined ||
    runtimeWindow.domAutomation !== undefined ||
    runtimeWindow.domAutomationController !== undefined
  ) {
    return true;
  }

  return false;
}

export function shouldBlockAutomationInCurrentRuntime(): boolean {
  if (typeof import.meta === "undefined") return false;

  const isDev = import.meta.env.DEV;
  const isLocalhost = isLocalhostHost();
  const isAutomation = isAutomationBrowser();

  return !isDev && !isLocalhost && isAutomation;
}
